import TextContentTranslationPagingResultModelBase from '../_generated/modelBases/text-content-translation-paging-result-model-base';

export default class TextContentTranslationPagingResultModel extends TextContentTranslationPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
